/* global requestAnimationFrame:true */
/* eslint no-undef: "error" */

const DEFAULT_OPTIONS = {
  // The trigger link that will collapse the collapsableClass in the same node
  triggerClass: null,
  // The element that will collapse
  collapsableClass: null,
  // The class to add when toggle
  toggleClass: 'is-open',
};

export default class Collapsable {
  constructor(options = {}) {
    this.options = Object.assign({}, DEFAULT_OPTIONS, options);

    this.run();
  }

  run() {
    let triggerNodes = document.querySelectorAll(
      '.' + this.options.triggerClass
    );

    if (triggerNodes.length > 0) {
      for (let i = 0; i < triggerNodes.length; i++) {
        // Define the collapsable container
        let collapsableContainer = triggerNodes[i].parentNode.querySelector(
          '.' + this.options.collapsableClass
        );

        // set the listener on the actual links
        this.addListener(triggerNodes[i], collapsableContainer);
      }
    }
  }

  addListener(element, collapsableContainer) {
    element.addEventListener(
      'click',
      function (e) {
        if (collapsableContainer) {
          // get the current height of the element that need to collapse
          let sectionHeight = parseInt(collapsableContainer.style.height);

          // Toggle the class for styling
          element.classList.toggle(this.options.toggleClass);

          if (isNaN(sectionHeight) || sectionHeight === 0) {
            this.expandSection(collapsableContainer);
          } else {
            this.collapseSection(collapsableContainer);
          }
        }
      }.bind(this)
    );
  }

  collapseSection(el) {
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = el.scrollHeight;

    // temporarily disable all css transitions
    var elTransition = el.style.transition;
    el.style.transition = '';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(function () {
      el.style.height = sectionHeight + 'px';
      el.style.transition = elTransition;

      // on the next frame (as soon as the previous style change has taken effect),
      // have the element transition to height: 0
      requestAnimationFrame(function () {
        el.style.height = 0 + 'px';
      });
    });
  }

  expandSection(el) {
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = el.scrollHeight;

    // have the element transition to the height of its inner content
    el.style.height = sectionHeight + 'px';
  }

  getChildNodes(node) {
    let children = [];

    if (node.childNodes.length > 0) {
      for (let i = 0; i < node.childNodes.length; i++) {
        if (node.childNodes[i].nodeType === 1) {
          children.push(node.childNodes[i]);
        }
      }

      return children;
    } else {
      return null;
    }
  }
}
